import { createCustomAction } from 'typesafe-actions';

import { Page } from '../common/typings';

export const changePage = createCustomAction('@canvasApp/CHANGE_PAGE', type => {
    return (page: Page, ideaId?: string) => ({ type, page, ideaId });
});

export const showBusy = createCustomAction('@canvasApp/SHOW_BUSY');

export const hideBusy = createCustomAction('@canvasApp/HIDE_BUSY');

export const showError = createCustomAction('@canvasApp/SHOW_ERROR', type => {
    return (msg: string) => ({ type, msg });
});

export type ChangePageAction = ReturnType<typeof changePage>;

export type CanvasAppAction =
    | ChangePageAction
    | ReturnType<typeof showError>
    | ReturnType<typeof showBusy>
    | ReturnType<typeof hideBusy>;
